export const FETCH_SITEMAP_BOARDS_FOR_LOCATION = 'FETCH_SITEMAP_BOARDS_FOR_LOCATION'
export const FETCH_SITEMAP_PUBLIC_LOCATIONS = 'FETCH_SITEMAP_PUBLIC_LOCATIONS'
export const SEARCH_PUBLIC_USERS = 'QUERY_PUBLIC_CITIES'
